<template>
    <form novalidate class="md-layout-item md-size-100 md-small-size-100" @submit.prevent="validateExpression()">
        <md-content class="md-layout-item md-pd-16 md-size-100 md-small-size-100">
            <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100">
                    <md-field :class="getExpressionValidationClass('name')">
                        <label for="expression-name">Nazwa</label>
                        <md-input name="expression-name" id="expression-name" v-model="expression.name" />
                        <span class="md-error" v-if="!$v.expression.name.required">{{ $t('views.admin.configurations.surchargeType.add.validation.expressionName') }}</span>
                    </md-field>
                </div>
            </div>
            <md-field :class="getExpressionValidationClass('value')">
                <label for="expressionValue">{{ $t('views.admin.configurations.surchargeType.add.labelForm.expressionValue') }}</label>
                <md-select :name="'value-select'" :id="'value-select'" v-model="expression.valueType.id"
                           md-dense>
                    <md-option v-for="(value) in values" :key="value.id" :value="value.id">
                        {{ value.name }}
                    </md-option>
                </md-select>
                <span class="md-error" v-if="!$v.expression.valueType.required">{{ $t('views.admin.configurations.surchargeType.add.validation.expressionValue') }}</span>
            </md-field>
            <md-field :class="getExpressionValidationClass('operator')">
                <label for="expressionOperator">{{ $t('views.admin.configurations.surchargeType.add.labelForm.expressionOperator') }}</label>
                <md-select v-model="expression.operator" name="operator" id="operator">
                    <md-option value="EQUALS">{{ $t('views.admin.configurations.surchargeType.add.operators.EQUALS') }}</md-option>
                    <md-option value="GREATER">{{ $t('views.admin.configurations.surchargeType.add.operators.GREATER') }}</md-option>
                    <md-option value="SMALLER">{{ $t('views.admin.configurations.surchargeType.add.operators.SMALLER') }}</md-option>
                    <md-option value="CONTAINS">{{ $t('views.admin.configurations.surchargeType.add.operators.CONTAINS') }}</md-option>
                    <md-option value="CONTAINS_EXACT">{{ $t('views.admin.configurations.surchargeType.add.operators.CONTAINS_EXACT') }}</md-option>
                </md-select>
                <span class="md-error" v-if="!$v.expression.operator.required">{{ $t('views.admin.configurations.surchargeType.add.validation.expressionValue') }}</span>
            </md-field>
            <md-field :class="getExpressionValidationClass('constValue')">
                <label for="expressionConstValue">{{ $t('views.admin.configurations.surchargeType.add.labelForm.expressionConstValue') }}</label>
                <md-input name="expression-name" id="expression-name" autocomplete="given-name"
                          v-model="expression.constValue" />
                <span class="md-error" v-if="!$v.expression.constValue.required">{{ $t('views.admin.configurations.surchargeType.add.validation.expressionConstValue') }}</span>
            </md-field>

            <div class="md-layout-item md-size-100 md-flex-right-align md-mt-30" style="min-height: 50px">
                <div class="button-actions">
                  <md-button class="md-form-btn-cancel md-mr-30" @click="cancel">
                      {{ $t('cancel') }}
                  </md-button>
                  <md-button v-if="edit" class="md-form-btn-white" type="submit">{{ $t('save') }}</md-button>
                  <md-button v-if="!edit" class="md-form-btn-white" type="submit">
{{
                      $t('views.admin.configurations.surchargeType.add.label') }}
                  </md-button>
                </div>
            </div>
        </md-content>
    </form>
</template>

<script>
  import {validationMixin} from 'vuelidate';
  import {required} from 'vuelidate/lib/validators';
  import {surchargesEndpoint} from '@/services/adsign-backend/endpoints';

  export default {
    name: 'ExpressionForm',
    mixins: [validationMixin],
    props: {
      id: {
        type: Number,
        default: undefined
      },
      discriminator: {
        type: String,
        required: true
      },
      surchargeTypeId: {
        type: String,
        default: undefined
      },
      item: {
        type: Object,
        default: undefined
      },
      index: {
        type: Number,
        default: undefined
      }
    },
    computed: {
      edit: {
        get() {
          return this.id !== undefined;
        }
      }
    },
    data: () => ({
      values: [],
      expression: {
        id: null,
        operator: null,
        constValue: null,
        name: null,
        valueType: {
          id: null,
          name: null
        },
        surchargeTypeId: null,
        index: null
      }
    }),

    validations: {
      expression: {
        name: {
          required,
        },
        valueType: {
          required,
        },
        operator: {
          required,
        },
        constValue: {
          required,
        }

      }
    },
    mounted() {
      if (this.edit) {
        this.loadSurchargeExpression();
      }
      if (this.item) {
        this.expression = this.item;
      }
      this.loadSurchargesExpressionValues();
    },
    methods: {
      loadSurchargeExpression() {
        return surchargesEndpoint.getSurchargeTypeExpression(this.id).then(result => {
          this.expression = result.data;
        });
      },
      loadSurchargesExpressionValues() {
        return surchargesEndpoint.getAllSurchargesExpressionValues(this.discriminator).then(result => {
          this.values = result.data;
        });
      },
      getExpressionValidationClass(fieldName) {
        const field = this.$v.expression[fieldName];

        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty
          }
        }
      },
      validateExpression() {
        this.$v.expression.$touch();

        if (!this.$v.expression.$invalid) {
          this.onExpressionSaved()
        }
      },
      updateSurchargeTypeExpression() {
        const formData = {
          id: this.expression.id,
          surchargeTypeId: this.expression.surchargeTypeId,
          name: this.expression.name,
          operator: this.expression.operator,
          constValue: this.expression.constValue,
          surchargeTypeValueId: this.expression.valueType.id,
          isDeleted: false
        };
        surchargesEndpoint.updateSurchargeTypeExpression(formData)
            .then((response) => {
              this.cancel();
            })
            .catch(this.handleServerValidationError)
            .finally(() => {
                  this.sending = false;
                }
            );
      },
      addSurchargeTypeExpressionForExistsSurcharge() {
        const formData = {
          id: this.expression.id,
          surchargeTypeId: this.surchargeTypeId,
          name: this.expression.name,
          operator: this.expression.operator,
          constValue: this.expression.constValue,
          surchargeTypeValueId: this.expression.valueType.id,
          isDeleted: false
        };
        surchargesEndpoint.addSurchargeTypeExpression(formData)
            .then((response) => {
              this.$router.push('/configurations/surchargeType/edit/' + this.surchargeTypeId);
            })
            .catch(this.handleServerValidationError)
            .finally(() => {
                  this.sending = false;
                }
            );
      },
      addSurchargeTypeExpression() {
        const formData = {
          id: this.expression.id,
          name: this.expression.name,
          operator: this.expression.operator,
          constValue: this.expression.constValue,
          valueType: this.values.find((item) => (item.id === this.expression.valueType.id)),
          isDeleted: false
        };
        //return information
        if (!this.item) {
          this.$emit('add', formData);
        } else {
          this.$emit('edit', formData);
        }
      },
      onExpressionSaved() {
        if (this.edit && this.expression.id) {
          // edit
          this.updateSurchargeTypeExpression();
        } else {
          // new
          if (this.surchargeTypeId) {
            // new for exists
            this.addSurchargeTypeExpressionForExistsSurcharge();
          } else {
            // new no exists
            this.addSurchargeTypeExpression();
          }
        }
      },
      cancel() {
        if (this.index) {
          this.$emit('edit', {index: this.index});
        } else if (this.edit) {
          this.$router.push('/configurations/surchargeType/edit/' + this.id);
        } else if (this.surchargeTypeId) {
          this.$router.push('/configurations/surchargeType/edit/' + this.surchargeTypeId);
        } else {
          this.$emit('edit', null);
        }
      },
    }
  }
</script>
